import React, { useEffect, useState } from "react";
import "./WelcomePage.css";
import backgroundImage from "../../../Assets/LoginImages/welcome_img.png";
import { useNavigate } from "react-router-dom";
import { getAuthToken } from "../../../utils/localStorage";
import { APP_CONFIG } from "../../../config/appConfig";

const WelcomePage = () => {
    const navigate = useNavigate()
    const token = getAuthToken()

    const [imageLoaded, setImageLoaded] = useState(false);

    const navigateToLogin = () => {
        navigate("/login")
    }

    useEffect(() => {
        if (token) navigate('/dashboard/dashboard/overview'); //IF TOKEN HAVE VALUE THE REDIRECT TO DASHBOARD
    }, [])

    useEffect(() => {
        // Preload the background image
        const img = new Image();
        img.src = backgroundImage;
        img.onload = () => setImageLoaded(true);
    }, []);

    return (
        <div
            className="tm-welcome-container"
            style={{
                // backgroundColor: "", // fallback color before image loads
                backgroundImage: imageLoaded ? `url(${backgroundImage})` : "none",
                transition: "background-image 0.8s ease-in-out",
            }}
        >
            {/* Logo Section */}
            <div className="tm-logo-container" style={{ opacity: imageLoaded ? 1 : 0, transition: "opacity 1s ease-in-out" }}>
                {/*  className="logo" */}
                {/* <img src={APP_CONFIG?.APP_LOGO} alt="Technomax Logo" className="tm-logo" /> */}
            </div>

            {/* Main Content */}
            <div className="tm-content" style={{ opacity: imageLoaded ? 1 : 0, transition: "opacity 1s ease-in-out" }}>
                {/* <div className="tm-content"> */}
                <img src={APP_CONFIG?.WELCOME_SCREEN_LOGO} alt="Technomax Logo"   className="tm-welcome-logo"/>
                <h1 className="tm-title">Welcome To {APP_CONFIG.APP_NAME}</h1>
                <h5 className="tm-subtitle">
                    {APP_CONFIG.TAG_LINE}
                </h5>

                {imageLoaded && <button className="tm-login-button" onClick={navigateToLogin}>Login</button>}
            </div>
        </div>
    );
};

export default WelcomePage;
